import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  list: {
    method: 'GET',
    url: `${configs.baseUrl}/api/brand-kits`,
  },
  create: {
    method: 'POST',
    url: `${configs.baseUrl}/api/brand-kits`,
  },
  update: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/brand-kits/{kitId}`,
  },
  saveControls: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/brand-kits/controls`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const list = async () => {
  const response = await resource.list()
  return response.body
}

const create = async ({ scope, name }) => {
  const response = await resource.create({ scope, ...(name ? { name } : {}) })
  return response.body
}

const update = async (kitId, patch) => {
  const response = await resource.update({ kitId }, patch)
  return response.body
}

const saveControls = async (controls) => {
  const response = await resource.saveControls({}, controls)
  return response.body
}

const uploadImage = async (file) => {
  const body = new FormData()
  body.append('file', file)
  const response = await Vue.http.post(configs.api.uploadImage, body)
  return response.body.file
}

const errorCodeOf = (error) => {
  const body = error && (error.body || error.data)
  return (body && body.code) || null
}

const isNotFound = (error) => Boolean(error) && error.status === 404

export default {
  initResource,
  list,
  create,
  update,
  saveControls,
  uploadImage,
  errorCodeOf,
  isNotFound,
}
